import { TMcpAccessLevel } from '@commenda/types/src/company/types';
import { fetcher } from '@commenda/utils';

export async function updateCompanyMcpMemberDefault(
  companyId: number,
  level: TMcpAccessLevel
): Promise<Response> {
  return fetcher(`company/${companyId}/mcp-access/default`, {
    method: 'PUT',
    body: { level },
  });
}

export async function updateCompanyMcpMemberAccess(
  companyId: number,
  userId: string,
  level: TMcpAccessLevel
): Promise<Response> {
  return fetcher(`company/${companyId}/mcp-access/member/${userId}`, {
    method: 'PUT',
    body: { level },
  });
}
